import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import styles from "./signup.module.scss";
import classNames from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import { handlePostRequest } from "../../services/PostTemplate";
import { toast } from "react-toastify";

function Signup() {
    const [role, setRole] = useState();
    const [next, setNext] = useState(0);
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");
    const [currentSlide, setCurrentSlide] = useState(0);
    const dispatch = useDispatch();
    let history = useHistory();

    const slides = [
        {
            id: 1,
            title: "Airport Operations",
            subtitle: "YOUR EXPRESS AIR EXPERTS",
            description: "Located at Fort Lauderdale Airport, we're set up for speed. Why store your packages in a warehouse when we can forward them immediately?",
            image: "https://res.cloudinary.com/dwxqg9so3/image/upload/v1758229560/araflane-with-cargo-tarmac-sunset-generative-ai-scaled_gkrgoj.jpg"
        },
        {
            id: 2,
            title: "48-Hour Delivery",
            subtitle: "US TO JA IN RECORD TIME",
            description: "Shop online using our Florida address. We receive, inspect, and process your packages, then we put them on the next flight to Jamaica. Simple, fast.",
            image: "https://res.cloudinary.com/dwxqg9so3/image/upload/v1758229572/freepik__aerial-view-of-fort-lauderdale-international-airpo__93335_b2ndqm.png"
        },
        {
            id: 3,
            title: "Sign Up Now",
            subtitle: "READY TO MOVE FORWARD?",
            description: "Get your US shipping address once you sign up and experience the difference airport-based operations make.",
            subdescription: "Contact Us! 954-408-2025 | help@wemove4wd.com",
            image: "https://res.cloudinary.com/dwxqg9so3/image/upload/v1758246573/laptop_kusm5m.jpg"
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide(prev => (prev + 1) % slides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [slides.length]);

    const validationSchema = Yup.object().shape({
        email: Yup.string().required("This field is required.").email("Invalid email format."),
        password: Yup.string().required("This field is required."),
        firstName: Yup.string().required("This field is required."),
        lastName: Yup.string().required("This field is required."),
        phone: Yup.string().required("This field is required."),
    });

    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
            firstName: "",
            lastName: "",
            phone: "",
            TRN: "",
            mailingAddress: "",
            deliveryAddress: "",
            businessName: "",
            TCC: "",
            businessType: "",
            dateJoined: "",
            role: "",
        },
        validationSchema,
        // explicit options (defaults are ok, but explicit is sometimes clearer)
        validateOnBlur: true,
        validateOnChange: true,
        onSubmit: async (data) => {
            if (loading) return;
            setloading(true);
            data.role = role;
            data.dateJoined = Date.now();
            try {
                const res = await dispatch(handlePostRequest(data, "/singup", true, true));
                if (res !== "error") {
                    localStorage.setItem("email", data.email);
                    toast.success(res?.data?.message);
                    history.push("/login");
                }
            } catch (err) {
                toast.error("Signup failed.");
            } finally {
                setloading(false);
            }
        },
    });

    // consider field touched OR form has been submitted (submitCount > 0)
    const isFormFieldValid = (name) => {
        return !!(((formik.touched[name]) || formik.submitCount > 0) && formik.errors[name]);
    };
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handleSignup = () => {
        // If role selected, continue to additional fields; otherwise try to submit
        if (role === "client" || role === "courier") {
            setNext(1);
        } else {
            // call submit — this will run validation and increase submitCount
            formik.handleSubmit();
        }
    };

    return (
        <div className={styles.signupBody}>
            <div className={styles.signupMainContainer}>
                <div className={styles.carouselSection}>
                    <div className={styles.carouselContainer}>
                        {slides.map((slide, index) => (
                            <div
                                key={slide.id}
                                className={`${styles.carouselSlide} ${index === currentSlide ? styles.active : ''}`}
                                style={{ backgroundImage: `url(${slide.image})` }}
                            >
                                <div className={styles.carouselOverlay}></div>
                                <div className={styles.carouselContent}>
                                    <div className={`${styles.glassCard} ${index === currentSlide ? styles.animate : ''}`}>
                                        <h3 className={`${styles.carouselSubtitle} ${index === currentSlide ? styles.animateSubtitle : ''}`}>
                                            {slide.subtitle}
                                        </h3>
                                        <h2 className={`${styles.carouselTitle} ${index === currentSlide ? styles.animateTitle : ''}`}>
                                            {slide.title}
                                        </h2>
                                        <p className={`${styles.carouselDescription} ${index === currentSlide ? styles.animateDescription : ''}`}>
                                            {slide.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.signupSection}>
                    <div className={styles.signupContainer}>
                        <div style={{ marginTop: "0%", marginBottom: "0%", textAlign: "center" }}>
                            <img
                                src="https://res.cloudinary.com/dwxqg9so3/image/upload/v1758210476/4wd_logo_big_croped_djegsi.jpg"
                                style={{ objectFit: "cover", height: "80px", width: "auto", marginTop: "20px" }}
                                alt="Move4wd logo"
                            />
                        </div>

                        <div className={styles.signupForms}>
                            <p className={styles.signupHeader}>
                                {next === 0 ? "Join the Move4wd family! Create your account" :
                                    role === "client" ? "Complete your client profile" :
                                        "Complete your courier profile"}
                            </p>
                            <p className={styles.signupSubHeader}>
                                {next === 0 ? "Start your journey with us and experience reliable logistics solutions." :
                                    role === "client" ? "Please provide additional information to complete your client registration." :
                                        "Please provide additional information to complete your courier registration."}
                            </p>

                            <form action="#" className={styles.formDiv} onSubmit={formik.handleSubmit} noValidate>
                                {next === 0 ? (
                                    <div className="p-mt-4">
                                        <input
                                            id="firstName"
                                            name="firstName"
                                            className={classNames({ "p-invalid": isFormFieldValid("firstName") }, styles.signupInput)}
                                            value={formik.values.firstName}
                                            placeholder="First Name"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("firstName")}

                                        <input
                                            id="lastName"
                                            name="lastName"
                                            className={classNames({ "p-invalid": isFormFieldValid("lastName") }, styles.signupInput)}
                                            value={formik.values.lastName}
                                            placeholder="Last Name"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("lastName")}

                                        <input
                                            id="email"
                                            name="email"
                                            className={classNames({ "p-invalid": isFormFieldValid("email") }, styles.signupInput)}
                                            value={formik.values.email}
                                            placeholder="Email Address"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="email"
                                        />
                                        {getFormErrorMessage("email")}

                                        <input
                                            name="password"
                                            className={classNames({ "p-invalid": isFormFieldValid("password") }, styles.signupInput)}
                                            placeholder="Password"
                                            value={formik.values.password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="password"
                                        />
                                        {getFormErrorMessage("password")}

                                        <input
                                            name="phone"
                                            className={classNames({ "p-invalid": isFormFieldValid("phone") }, styles.signupInput)}
                                            placeholder="Phone Number"
                                            value={formik.values.phone}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="tel"
                                        />
                                        {getFormErrorMessage("phone")}

                                        <select
                                            className={styles.signupSelect}
                                            value={role || ""}
                                            onChange={(e) => setRole(e.target.value)}
                                        >
                                            <option value="" disabled>Select Your Role</option>
                                            <option value="client">Client</option>
                                            <option value="courier">Courier</option>
                                        </select>

                                        <div className="p-mt-2" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                            <Button
                                                className={styles.signupButton}
                                                label="Continue"
                                                icon={loadingIcon || ""}
                                                iconPos="right"
                                                type="button"
                                                disabled={loading}
                                                onClick={handleSignup}
                                            />
                                        </div>
                                    </div>
                                ) : role === "client" ? (
                                    <div className="p-mt-4">
                                        <input
                                            id="TRN"
                                            name="TRN"
                                            className={classNames({ "p-invalid": isFormFieldValid("TRN") }, styles.signupInput)}
                                            value={formik.values.TRN}
                                            placeholder="TRN Number"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("TRN")}

                                        <input
                                            id="mailingAddress"
                                            name="mailingAddress"
                                            className={classNames({ "p-invalid": isFormFieldValid("mailingAddress") }, styles.signupInput)}
                                            value={formik.values.mailingAddress}
                                            placeholder="Mailing Address"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("mailingAddress")}

                                        <input
                                            id="deliveryAddress"
                                            name="deliveryAddress"
                                            className={classNames({ "p-invalid": isFormFieldValid("deliveryAddress") }, styles.signupInput)}
                                            value={formik.values.deliveryAddress}
                                            placeholder="Delivery Address"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("deliveryAddress")}

                                        <div className={styles.buttonGroup}>
                                            <Button
                                                className={styles.backButton}
                                                label="Back"
                                                type="button"
                                                disabled={loading}
                                                onClick={() => setNext(0)}
                                            />
                                            <Button
                                                className={styles.signupButton}
                                                label="Sign Up"
                                                type="submit"
                                                disabled={loading}
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="p-mt-4">
                                        <input
                                            id="TRN"
                                            name="TRN"
                                            className={classNames({ "p-invalid": isFormFieldValid("TRN") }, styles.signupInput)}
                                            value={formik.values.TRN}
                                            placeholder="TRN Number"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("TRN")}

                                        <input
                                            id="mailingAddress"
                                            name="mailingAddress"
                                            className={classNames({ "p-invalid": isFormFieldValid("mailingAddress") }, styles.signupInput)}
                                            value={formik.values.mailingAddress}
                                            placeholder="Mailing Address"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("mailingAddress")}

                                        <input
                                            id="deliveryAddress"
                                            name="deliveryAddress"
                                            className={classNames({ "p-invalid": isFormFieldValid("deliveryAddress") }, styles.signupInput)}
                                            value={formik.values.deliveryAddress}
                                            placeholder="Delivery Address"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("deliveryAddress")}

                                        <input
                                            name="TCC"
                                            className={classNames({ "p-invalid": isFormFieldValid("TCC") }, styles.signupInput)}
                                            placeholder="TCC Number"
                                            value={formik.values.TCC}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("TCC")}

                                        <input
                                            name="businessName"
                                            className={classNames({ "p-invalid": isFormFieldValid("businessName") }, styles.signupInput)}
                                            placeholder="Business Name"
                                            value={formik.values.businessName}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("businessName")}

                                        <input
                                            name="businessType"
                                            className={classNames({ "p-invalid": isFormFieldValid("businessType") }, styles.signupInput)}
                                            placeholder="Business Type"
                                            value={formik.values.businessType}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            type="text"
                                        />
                                        {getFormErrorMessage("businessType")}

                                        <div className={styles.buttonGroup}>
                                            <Button
                                                className={styles.backButton}
                                                label="Back"
                                                type="button"
                                                disabled={loading}
                                                onClick={() => setNext(0)}
                                            />
                                            <Button
                                                className={styles.signupButton}
                                                label="Sign Up"
                                                type="submit"
                                                disabled={loading}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className={styles.mobileOnly}>
                                    <p style={{ marginTop: "15px", color: "white" }}>
                                        Already have an account?
                                        <Link to="/login" style={{ color: "#4a90e2", marginLeft: "5px" }}>Sign In Here</Link>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <footer className={styles.footer}>
                <div className={styles.footerContent}>
                    <div className={styles.footerLeft}>
                        <p>© {new Date().getFullYear()} Move4wd. All rights reserved.</p>
                    </div>
                    <div className={styles.footerCenter}>
                        <p>Moving your world, forward.</p>
                    </div>
                    <div className={styles.footerRight}>
                        <div className={styles.footerLinks}>
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Signup;